import { jsx as a } from "react/jsx-runtime";
const l = (n) => {
  const { items: e, nodeRef: i, className: r = "", ...t } = n;
  return /* @__PURE__ */ a(
    "ul",
    {
      ...t,
      className: `ApplicationActionBar nav navbar-nav navbar-right ${r}`,
      ref: i,
      children: e?.map((o, s) => /* @__PURE__ */ a("li", { role: "presentation", className: "navigationItem", children: o }, s))
    }
  );
};
export {
  l as default
};
//# sourceMappingURL=ApplicationActionBar.js.map
